import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import { FormattedMessage } from '../Intl';

import './ValueProps.less';

const CNAME = 'ValueProps';

const ValuePropsItem = ({ title, blurb }) => (
  <li className={`${CNAME}__item`}>
    <strong className={`${CNAME}__title`}>{title}</strong>
    <span className={`${CNAME}__blurb`} dangerouslySetInnerHTML={{ __html: blurb }} />
  </li>
);

const ValueProps = () => (
  <div className={cnames(CNAME, 'hidden-xs')}>
    <ul className={`${CNAME}__list`}>
      <FormattedMessage id={['home.sellingpoints.1.title', 'home.sellingpoints.1.blurb']}>
        {(title, blurb) => (<ValuePropsItem {...{ title, blurb }} />)}
      </FormattedMessage>
      <FormattedMessage id={['home.sellingpoints.2.title', 'home.sellingpoints.2.blurb']}>
        {(title, blurb) => (<ValuePropsItem {...{ title, blurb }} />)}
      </FormattedMessage>
      <FormattedMessage id={['home.sellingpoints.3.title', 'home.sellingpoints.3.blurb']}>
        {(title, blurb) => (<ValuePropsItem {...{ title, blurb }} />)}
      </FormattedMessage>
    </ul>
  </div>
);

ValuePropsItem.propTypes = {
  title: PropTypes.string.isRequired,
  blurb: PropTypes.string.isRequired
};

export default ValueProps;



// WEBPACK FOOTER //
// ./src/universal/components/ValueProps/ValueProps.js